import Clipboard from "clipboard";
import _ from "lib/underscore";
import loading from "../../../core/widgets/loading";
import {Notifier} from "../../../core/widgets/notifier";
import {siteUrl} from "../../../core/utils/url";
import {openHtmlDialog} from "../../../core/widgets/dialog";
import {globals} from "../../../core/utils/globals";

export function initSaleAdminPanelForList($listWrapper, selector) {
	$listWrapper = $($listWrapper);
	$listWrapper.on('click', selector + ' [rel=change-status]', function() {
		onClickChangeStatus($(this));
	});
}

export function initSaleAdminPanel(selector) {
	const $wrap = $(selector);
	if (!$wrap || !$wrap.length) {
		return;
	}

	$wrap.find('[rel=change-status]').on('click', function () {
		onClickChangeStatus($(this));
	});

	initSaleTemplatesCopy($wrap.find('[rel=copy-template]'));
}

function onClickChangeStatus($wrap) {
	if (!$wrap || !$wrap.length || $wrap.data('isWorking')) {
		return;
	}
	const id = $wrap.data('pageId');
	const $status = $wrap.find('[rel=page-status]');
	const status = $status.text();
	$wrap.data('isWorking', true);
	loading.show();
	$.post(siteUrl('blog/changePageStatus'), {id, status}, null, 'json')
		.always(loading.hide)
		.fail(Notifier.errorXHR)
		.done(response => {
			if (!response || !response.success) {
				Notifier.error();
			}
			else {
				const newStatus = response.status;
				$status.text(newStatus);
				Notifier.success('Статус изменен на ' + newStatus);
				$wrap.data('isWorking', false);
			}
		});
}

/**
 * Initialize copy-template admin block
 * @param {JQuery} $wrap
 */
export function initSaleTemplatesCopy($wrap) {
	if (!$wrap || !$wrap.length) {
		return;
	}
	const items = globals('saleTemplateItems');
	if (!items) {
		return;
	}
	const $select = $wrap.find('select[rel=template-items]');
	$.each(items, (id, name) => {
		$select.append(
			$('<option></option>').attr('value', id).text(name)
		);
	});

	const clipboard = new Clipboard('#btnCopySaleTemplate', {
		text: () => {
			return $wrap.data('content');
		}
	});
	const page_id = $wrap.data('pageId');
	const $buttons = $wrap.find('button.main');
	const $buttonsTg = $wrap.find('button.tg');
	let zresponse = '';
	$select.on('change', function () {
		$buttons.prop('disabled', true);
		$buttonsTg.prop('disabled', true);
		const template_id = $(this).val();
		if (!template_id) {
			return;
		}
		loading.show();
        const selected = $(this).val();
        const text = $(this).find('option[value="'+selected+'"]').text();
		$.get(siteUrl('sale/ajax_get_template'), {page_id, template_id}, null, 'json')
			.always(loading.hide)
			.fail(Notifier.errorXHR)
			.done(response => {
				$wrap.data('content', response['content']);
				$buttons.prop('disabled', false);
				zresponse = response.content;
                if(text.indexOf('TG') + 1){
                    $buttonsTg.prop('disabled', false);
                }
			});
	});
	clipboard.on('success', function (e) {
		Notifier.success('Шаблон скопирован в буффер обмена');
	});
	$wrap.find('[rel=btn-view-template]').on('click', () => {
		const content = _.escape($wrap.data('content'));
		openHtmlDialog(`<pre style="white-space: pre-wrap; word-break: break-all;">${content}</pre>`);
	});
	$('#btn-tg-test').click(function(){
		let request = {
			text: zresponse,
            chat_id: '-1001283636934',
			parse_mode: 'Markdown'
		}

        $.post(siteUrl('blog/telegramPost'), request, function(response){
            updateResponse(response);
        }, 'json');
	})
    $('#btn-tg-prod').click(function(){
        let request = {
            text: zresponse,
            chat_id: '-1001220675019',
            parse_mode: 'Markdown'
        }

        $.post(siteUrl('blog/telegramPost'), request, function(response){
            updateResponse(response);
        }, 'json');
    })

	function updateResponse(response){
        if(response.success){
            zde.notifier.success('Сообщение отправлено');
        } else {
            zde.notifier.error('Произошла ошибка');
        }
	}
}



// WEBPACK FOOTER //
// ./modules/blog/common/adminpanel.js